import React, { useState } from "react";
import { Alert, Empty } from "antd";
import { asset, formatMetric } from "../memberData";
import MemberAvatar from "../member-avatar/MemberAvatar";

export default function CustomerOverview({ member }) {
  const [benefitsExpanded, setBenefitsExpanded] = useState(false);
  const stats = [
    ["Số giờ hát", member.hours, "overview-imgMaskGroup.svg", "hours"],
    ["Tổng điểm hát", member.score, "overview-imgGroup1.svg", "score"],
    ["Số lượt ghé", member.visits, "overview-imgIcRoundHome.svg", "visits"],
  ];
  return <section aria-label="Tổng quan thành viên" className="member-overview">
    {member.message && <Alert className="member-profile-notice" type="info" message={member.message} />}
    <div className="member-hero">
      <div className="member-identity">
        <MemberAvatar member={member} decorated />
        <div className="member-greeting"><h2>Xin chào, {member.name}!</h2><p>{member.tierLabel}{member.level !== null ? ` · Level ${formatMetric(member.level)}` : ""}</p></div>
      </div>
      <div className="member-stats">
        {stats.map(([label, value, icon, tone]) => <div key={tone} className={`member-stat member-stat-${tone}`}>
          <span className="member-stat-icon"><img src={asset(icon)} alt="" /></span>
          <div className="member-stat-value"><strong className={formatMetric(value).length > 5 ? "member-stat-number-long" : undefined} aria-label={`${label}: ${value === null ? "chưa có dữ liệu" : formatMetric(value)}`}>{value === null ? "N/A" : formatMetric(value)}</strong><span>{label}</span></div>
        </div>)}
      </div>
      {stats.some(([, value]) => value === null) && <p className="member-stat-note">N/A: chưa có dữ liệu thống kê</p>}
    </div>
    <div className="member-rewards">
      <h3>Điểm tích lũy</h3>
      <div className="member-points">
        <div className="member-points-art" aria-hidden="true">
          {["111", "31", "11", "23", "101"].map((name, i) => <img key={name} className={`member-point-decoration decoration-${i}`} src={asset(`overview-imgLayer${name}.png`)} alt="" />)}
          <img className="member-point-medal" src={asset("overview-img14Cd587331A133C15A8Bdffd8344C0A2Copy1.png")} alt="" />
        </div>
        <div className="member-points-value"><img src={asset("overview-imgVector.svg")} alt="" /><strong className={formatMetric(member.points).length > 6 ? "member-points-number-long" : undefined}>{formatMetric(member.points)}</strong></div>
        <p>Điểm thành viên của bạn</p>
      </div>
      <div className="member-rewards-heading"><h3>Ưu đãi theo hạng</h3>{member.benefits.length > 1 && <button type="button" aria-expanded={benefitsExpanded} onClick={() => setBenefitsExpanded(!benefitsExpanded)}>{benefitsExpanded ? "Thu gọn" : "Xem thêm"}</button>}</div>
      {member.benefits.length ? <div className="member-benefit-list">
        {(benefitsExpanded ? member.benefits : member.benefits.slice(0, 1)).map((benefit, index) => <article className="member-benefit" key={`${index}-${benefit}`}>
          <span className="member-benefit-tier">{member.tierLabel}</span><p>{benefit}</p>
        </article>)}
      </div> : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Chưa có ưu đãi theo hạng" />}
    </div>
  </section>;
}
